import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import LoginForm from "../components/LoginForm";

const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "") + "/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [message, setMessage] = useState("Verifying...");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setMessage("Invalid verification link.");
      return;
    }
    fetch(`${API_BASE}/verify_email?token=${encodeURIComponent(token)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setMessage("Email verified. You may now log in.");
        } else {
          setMessage(data.error || "Verification failed");
        }
      })
      .catch(() => setMessage("Network error"));
  }, [params]);

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <p>{message}</p>
      <LoginForm />
    </div>
  );
}
